import React, { useEffect, useState } from 'react';

import {
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import { resetPassword } from 'controllers/user/resetPassword';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    zIndex: 10,
  },
  contentContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    maxWidth: '400px',
    paddingBottom: '84px',
  },
  title: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: 1.3,
    letterSpacing: '0.26px',
    marginBottom: '10px',
  },
  subTitle: {
    color: '#a4a8ac',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: 1.33,
    marginBottom: '20px',
  },
  input: {
    marginBottom: '20px',
    '& .Mui-error': {
      color: '#49515a',

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#8d3b51',
      },
    },
    '& .MuiFormHelperText-root': {
      color: '#8d3b51',
      marginLeft: 0,
      marginTop: '10px',
    },
  },
  button: {
    height: '60px',
  },
});

export const CollectEmail = ({
  setIsLoading,
  setScreen,
  setResetId,
  setShowVerificationCodeSent,
}) => {
  const classes = useStyles();
  const [hasError, setHasError] = useState('');
  const [emailId, setEmailId] = useState('');

  useEffect(() => {
    return () => {
      setHasError('');
      setEmailId('');
    };
  }, []);

  const onClickSend = async () => {
    setIsLoading(true);
    const response = await resetPassword(emailId);

    if (response.message === 'redirect') {
      setResetId(response.data);
      setScreen(1);
      setShowVerificationCodeSent(true);
    } else {
      setHasError(response.message);
    }

    setIsLoading(false);
  };

  const onChangeEmailId = (e) => {
    setHasError('');
    setEmailId(e.target.value);
  };

  return (
    <Grid container classes={{ root: classes.container }}>
      <Grid item xs={12} classes={{ root: classes.contentContainer }}>
        <Typography classes={{ root: classes.title }}>
          Forgot Password
        </Typography>
        <Typography classes={{ root: classes.subTitle }}>
          Dont worry we got you covered, recover your password within minutes
        </Typography>
        <TextField
          label="Email Id"
          variant="outlined"
          classes={{ root: classes.input }}
          onChange={onChangeEmailId}
          value={emailId}
          error={hasError}
          helperText={hasError}
        />
        <Button
          variant="contained"
          color="primary"
          classes={{ root: classes.button }}
          onClick={onClickSend}
          disabled={!emailId || hasError}
        >
          Send verification code
        </Button>
      </Grid>
    </Grid>
  );
};
